import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh', padding: 'var(--vn-space-6)' }}>
      <EmptyState
        title={t('notFound.title')}
        description={t('notFound.description')}
        actions={
          <Button asChild variant="primary">
            <Link to="/">{t('common.backToOverview')}</Link>
          </Button>
        }
      />
    </div>
  );
}
